<template>
    <div class="open-container">
        <Nav :currentActive="'Open'" />

        <div class="open-banner">
            <div class="banner">
                <img src="@/assets/images/open-banner.jpg" />
            </div>
            <div class="banner-desc">
                <div class="banner-desc-text">
                    <div class="title">开放合作</div>
                    <div class="text">澳琴链面向湾区各产业行业提供标识注册及解析服务、信息系统建设和运营、服务应用对接和推广等服务，同时提供客制化产业数字转型业务。</div>
                </div>
                
            </div>
            <div class="num-rain">
                <NumberRain />
            </div>
        </div>
        <div class="open-text pt110 pb110">
            <div class="contain">
                <div class="com-tit fs34 text-center wow fadeInUp" data-wow-delay="0.3s" style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;">
	                产品与服务
                </div>
                <ul class="list mt24 flex flex-justify-between flex-wrap-wrap">
                    <li class="item wow fadeInUp" data-wow-delay="0.12s" style="visibility: visible; animation-delay: 0.12s; animation-name: fadeInUp;">
                        <div class="icon">
                            <img src="@/assets/images/open-text-icon-c.png" class="c" ondragstart="return false">
                            <img src="@/assets/images/open-text-icon-w.png" class="w" ondragstart="return false"> 
                        </div>
                        <div class="title fs20 mt20">
                            公共数据
                        </div>
                        <p>
                            提供企业资讯、用户身份、知识产权、资讯服务等公共数据价值交换服务，通过用户之间点对点数据交互的方式，实现数字资产价值化交换、转移过程。
                        </p>
                    </li>
                    <li class="item wow fadeInUp" data-wow-delay="0.24s" style="visibility: visible; animation-delay: 0.24s; animation-name: fadeInUp;">
                        <div class="icon">
                            <img src="@/assets/images/open-text-icon2-c.png" class="c" ondragstart="return false"><img src="@/assets/images/open-text-icon2-w.png" class="w" ondragstart="return false"> 
                        </div>
                        <div class="title fs20 mt20">
                            标识资源
                        </div>
                        <p>
                            对新型分布式标识及现有标识体系的多标识根区数据资源管理服务，实现根区平等共治、资源自主管理。
                        </p>
                    </li>
                    <li class="item wow fadeInUp" data-wow-delay="0.36s" style="visibility: visible; animation-delay: 0.36s; animation-name: fadeInUp;">
                        <div class="icon">
                            <img src="@/assets/images/open-text-icon3-c.png" class="c" ondragstart="return false"><img src="@/assets/images/open-text-icon3-w.png" class="w" ondragstart="return false"> 
                        </div>
                        <div class="title fs20 mt20">
                            标识解析
                        </div>
                        <p>
                            提供企业资讯、用户身份、知识产权、资讯服务等公共数据价值交换服务，通过用户之间点对点数据交互的方式，实现数字资产价值化交换、转移过程。
                        </p>
                    </li>
                    <li class="item wow fadeInUp" data-wow-delay="0.48s" style="visibility: visible; animation-delay: 0.48s; animation-name: fadeInUp;">
                        <div class="icon">
                            <img src="@/assets/images/open-text-icon4-c.png" class="c" ondragstart="return false"><img src="@/assets/images/open-text-icon4-w.png" class="w" ondragstart="return false"> 
                        </div>
                        <div class="title fs20 mt20">
                            监管规则
                        </div>
                        <p>
                            提供由国家监管部门管理的链网许可监管规则，对接入主链的同构/异构区块链实行穿透式监管。
                        </p>
                    </li>
                    <li class="item wow fadeInUp" data-wow-delay="0.12s" style="visibility: visible; animation-delay: 0.12s; animation-name: fadeInUp;">
                        <div class="icon">
                            <img src="@/assets/images/open-text-icon5-c.png" class="c" ondragstart="return false"><img src="@/assets/images/open-text-icon5-w.png" class="w" ondragstart="return false"> 
                        </div>
                        <div class="title fs20 mt20">
                            国家背书
                        </div>
                        <p>
                            对新型分布式标识及现有标识体系的多标识根区数据资源管理服务，实现根区平等共治、资源自主管理。
                        </p>
                    </li>
                    <li class="item wow fadeInUp" data-wow-delay="0.24s" style="visibility: visible; animation-delay: 0.24s; animation-name: fadeInUp;">
                        <div class="icon">
                            <img src="@/assets/images/open-text-icon6-c.png" class="c" ondragstart="return false"><img src="@/assets/images/open-text-icon6-w.png" class="w" ondragstart="return false"> 
                        </div>
                        <div class="title fs20 mt20">
                            联盟治理
                        </div>
                        <p>
                            对新型分布式标识及现有标识体系的多标识根区数据资源管理服务，实现根区平等共治、资源自主管理。
                        </p>
                    </li>
                    <li class="item wow fadeInUp" data-wow-delay="0.36s" style="visibility: visible; animation-delay: 0.36s; animation-name: fadeInUp;">
                        <div class="icon">
                            <img src="@/assets/images/open-text-icon7-c.png" class="c" ondragstart="return false"><img src="@/assets/images/open-text-icon7-w.png" class="w" ondragstart="return false"> 
                        </div>
                        <div class="title fs20 mt20">
                            行业自治
                        </div>
                        <p>
                            各行业子链业务模式和过程共识机制由其独立运行，并根据主链规范实现同构/异构区块链的跨链交互和互操作性。
                        </p>
                    </li>
                    <li class="item wow fadeInUp" data-wow-delay="0.48s" style="visibility: visible; animation-delay: 0.48s; animation-name: fadeInUp;">
                        <div class="icon">
                            <img src="@/assets/images/open-text-icon8-c.png" class="c" ondragstart="return false"><img src="@/assets/images/open-text-icon8-w.png" class="w" ondragstart="return false"> 
                        </div>
                        <div class="title fs20 mt20">
                            体系架构高可用
                        </div>
                        <p>
                            采用可插拔“1+N”主子链群架构，各行业可根据业务需要定制其底层链功能及应用服务，旨在面向全行业构建一套基于区块链技术的基础设施，主推企业数字资产价值化转移。
                        </p>
                    </li>
                <!-- 占位 -->
                    <!-- <li class="item placeholder wow fadeInUp" data-wow-delay="0.12s" style="visibility: visible; animation-delay: 0.12s; animation-name: fadeInUp;">
                    </li>
                    <li class="item placeholder wow fadeInUp" data-wow-delay="0.24s" style="visibility: visible; animation-delay: 0.24s; animation-name: fadeInUp;">
                    </li> -->
                </ul>
            </div>
        </div>

        <div class="open-partner pt110 pb110">
            <div class="contain">
                <div class="com-tit fs34 text-center wow fadeInUp" data-wow-delay="0.3s" style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;">战略合作伙伴</div>
                <div class="coo-logo-list mt46 wow com-animate-f" data-wow-delay="0.6s" style="visibility: visible; animation-delay: 0.6s;">
                    <ul class="flex flex-wrap-wrap">
                        
                        <li><img src="@/assets/images/logo-1.png" class="full-maxAuto" ondragstart="return false"></li>
                        <li><img src="@/assets/images/logo-2.png" class="full-maxAuto" ondragstart="return false"></li>
                        <li><img src="@/assets/images/logo-3.png" class="full-maxAuto" ondragstart="return false"></li>
                        <li><img src="@/assets/images/logo-4.png" class="full-maxAuto" ondragstart="return false"></li>
                        <li><img src="@/assets/images/logo-5.png" class="full-maxAuto" ondragstart="return false"></li>
                        <li><img src="@/assets/images/logo-6.png" class="full-maxAuto" ondragstart="return false"></li>
                        <li><img src="@/assets/images/logo-7.png" class="full-maxAuto" ondragstart="return false"></li>
                        <li><img src="@/assets/images/logo-8.png" class="full-maxAuto" ondragstart="return false"></li>
                        <li><img src="@/assets/images/logo-9.png" class="full-maxAuto" ondragstart="return false"></li>
                        <li><img src="@/assets/images/logo-10.png" class="full-maxAuto" ondragstart="return false"></li>
                        <li><img src="@/assets/images/logo-11.png" class="full-maxAuto" ondragstart="return false"></li>
                        <li><img src="@/assets/images/logo-12.png" class="full-maxAuto" ondragstart="return false"></li>
                        
                        
                    </ul>
                </div>
            </div>
        </div>
        
        <Footer />
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import Nav from '../../components/NavTop.vue';
  import Footer from '../../components/Footer.vue';
  import NumberRain from '../../components/NumberRain.vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .open-container {
    padding-top: 84px;
 }

 .open-banner {
    position: relative;
 }
 .open-banner .banner {
    width: 100%;
 }
 .open-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .open-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .open-banner .banner-desc .title {
    font-size: 30px;
 }
 .open-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .num-rain {
    display: flex;
    position: absolute;
    left: 0;
    height: 100%;
    width: 100%;
    top: 0;
    overflow: hidden;
}

    .open-text {
        padding: 90px 0;
    }
    .contain {
        margin: 0 auto;
        width: 1200px;
    }
    .com-tit {
        color: #333333;
        font-weight: 500;
        line-height: 1.1;
        font-size: 28px;
        text-align: center;
    }
    .list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 20px;
    }
    .open-text .list .item {
        background: #e7eef9;
        height: 330px;
        padding: 40px 28px;
        width: calc(24% - 56px);
        border-radius: 4px;
        position: relative;
        transition: background-color .4s ease;
        margin-top: 20px;
    }
    .open-text .list .item:hover {
        background: #1c4892; 
    }
    .open-text .list .item:after {
        content: '';
        background: url(@/assets/images/open-text-item-bg.png) no-repeat bottom -100px right -40px / 100%;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        opacity: 0;
        transition: opacity .4s ease, transform .6s ease;
        transform: scale(0.8);
        transform-origin: right bottom;
        background-position: bottom -60px right -40px;
    }
    .open-text .list .item:hover:after {
        opacity: 1;
        transform: scale(1); 
    }
    .open-text .list .item:hover .icon .w {
        display: block;
    }
    .open-text .list .item:hover .icon .c {
        display: none;
    }
    .open-text .list .item:hover .title,
    .open-text .list .item:hover p {
        color: #FFFFFF;
    }
    .open-text .list .item .icon {
        transition: transform .4s ease;
    }
    .open-text .list .item .icon .w {
        display: none;
    }
    .open-text .list .item .title {
        color: #333333;
        font-weight: 500;
        transition: color .4s ease;
        margin-top: 18px;
        font-size: 20px;
    }
    .open-text .list .item p {
        font-size: 15px;
        line-height: 24px;
        color: #666666;
        margin-top: 10px;
        transition: color .4s ease;
    }

    .open-partner {
        background: url(@/assets/images/open-partner-bg.jpg) no-repeat center / cover;
        padding: 90px 0;
    }
    .contain {
        margin: 0 auto;
        width: 1200px;
    }
    .coo-logo-list {
        margin-top: 34px;
    }
    .coo-logo-list ul {
        margin: -12px 0 0 -12px;
        display: flex;
        flex-wrap: wrap;
    }
    .coo-logo-list li {
        border-radius: 5px;
        transition: all .4s ease;
        background: #fff;
        height: 90px;
        width: calc(16.66% - 12px);
        margin-left: 12px;
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 13px 17px 0px rgba(152, 172, 194, 0.14);
    }
    .coo-logo-list li:hover {
        transform: translateY(-4px);
        box-shadow: 0px 13px 17px 0px rgba(152, 172, 194, 0.33);
    }
  </style>